<template>
    <div class="wrapper">
        <img src="../../assets/arrowleft.png" @click="left" class="left"/>
        <div class="list-buttons" name="list-buttons" ref="scrollref">
        
            <button @click="index === selected ? null : select(index)" v-for="(document, index) in list" :key="index"
                :class="index === selected ? 'active':'inactive'"
            >{{ convert(document) }}</button>
                
        </div>
        <img src="../../assets/arrowright.png" @click="right" class="right"/>
    </div>
</template>

<script>
export default {
    name: 'listButtons',
    props: ['list', 'selectedIndex'],
    data: function()
    {
        return {
            selected: 0,
            step: 200,
        }
    },
    mounted: function()
    {
        this.selected = this.selectedIndex;
    },
    methods: {
        right() {
            if (this.$refs.scrollref) {
                this.$refs.scrollref.scrollBy({ left: this.step, behavior: 'smooth' })
            }
        },
        left() {
            if (this.$refs.scrollref) {
                this.$refs.scrollref.scrollBy({ left: -this.step, behavior: 'smooth' })
            }
        },
        select: function(index)
        {
            this.selected = index;
            this.$emit('select', this.selected)
        },
        convert: function(name)
        {
            name = name.replace(".png", "");

            if(name === '거래명세서_전극')
            {
                return '명세서_전극'
            }
            else if(name === '결제영수증_전극')
            {
                return '영수증_전극'
            }
            else if(name === '거래명세서_일반소모성')
            {
                return '명세서_소모성'
            }
            else if(name === '결제영수증_일반소모성')
            {
                return '영수증_소모성'
            } 
            else if(name.indexOf(".pdf") > -1)
            {
                return name.replace(".pdf", "");
            }
            else 
            {
                return name;
            }
        }
    }
}
</script>

<style scoped>

    .list-buttons {
        width: 100%;
        overflow-x: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .active {
        display: flex;
        height: 36px;
        padding: 6px 8px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: #184FA1;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-right: 8px;
    }
    .inactive {
        display: flex;
        height: 36px;
        padding: 6px 8px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
        margin-right: 8px;
    }
    .wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .left {
        width: 22px;
        margin-right: 8px;
    }
    .right {
        width: 22px;
        margin-left: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/ListButtons.vue